
<div class="avatar">
    <div class="circle" [style.backgroundColor]="color">
        <span>{{firstLetter}}</span>
    </div>
</div>